<script setup>
</script>
<template>
  <section id="about" class="about-section">
    <h2>About Us</h2>

    <div class="return-policy">
      <h2>Returns & Refunds Policy</h2>

      <p>We want you to be happy with your purchase from <strong>Bumblefox UK</strong>.</p>

      <h3>Damaged or Faulty Items (Up to 30 Days)</h3>
      <p>If your item arrives <strong>damaged</strong> or develops a <strong>fault within 30 days</strong> of delivery, please contact us with details and photos where possible. We will arrange a <strong>replacement or refund</strong> as appropriate.</p>

      <h3>Change of Mind Returns (7 Days)</h3>
      <p>If you change your mind, you can return your item within <strong>7 days of receiving it</strong> for a refund. Items must be returned in their <strong>original condition</strong>.</p>

      <h3>Return Postage</h3>
      <p><strong>Customers are responsible</strong> for the cost of returning items to us.</p>

      <h3>Replacements</h3>
      <p>Where a replacement is agreed, we will <strong>cover the cost of sending the replacement item</strong> back to you.</p>

      <h3>How to Start a Return</h3>
      <p>To start a return, please contact us at <strong>Bumblefoxuk@gmail.com</strong> with your order information.</p>

      <p><em>We reserve the right to refuse returns that do not meet the conditions outlined above.</em></p>
    </div>
  </section>
</template>
